import { IN_NETWORK_INSURANCE_KEY } from './components/InNetworkInsurance/constants';
import { INSURANCE_PICKER_KEY, insurancePickerReducer } from '@zocdoc/components/src/InsurancePicker/';
import { INSURANCE_STATE_KEY, insuranceReducer } from '@zocdoc/components/src/InsuranceForm';
import { LOCATIONS_CAROUSEL_KEY } from '../../Shared/LocationCardCarousel/constants';
import { NEW_EXISTING_RADIO_STATE_KEY } from '@zocdoc/components/src/newexistingradio/NewExistingRadioSelector';
import { newExistingRadioReducer } from '@zocdoc/components/src/newexistingradio/NewExistingRadioReducer';
import { PICTURE_GALLERY_KEY } from './components/PictureGallery/constants';
import { pictureGalleryReducer } from './components/PictureGallery/PictureGalleryReducer';
import { PROCEDURE_DROPDOWN_STATE_KEY } from '@zocdoc/components/src/ProcedureDropdown/ProcedureDropdownSelector';
import { procedureDropdownReducer } from '@zocdoc/components/src/ProcedureDropdown';
import { universalSearchReducer, UNIVERSAL_SEARCH_KEY } from '@zocdoc/components/src/universalsearch';
import { REVIEWS_KEY } from './components/Reviews/constants';
import { NEXT_AVAILABILITY_KEY } from './components/NextAvailability/constants';
import { ROOT_KEY } from './state/constants';
import inNetworkInsuranceReducer from './components/InNetworkInsurance/reducer';
import locationsCardCarouselReducer from '../../Shared/LocationCardCarousel/reducer';
import pageReducer from './state/reducer';
import reviewsReducer from './components/Reviews/reducer';
import nextAvailabilityReducer from './components/NextAvailability/reducer';
import { INVITE_DOCTOR_FORM_KEY } from './components/InviteDoctorForm/constants';
import inviteDoctorFormReducer from './components/InviteDoctorForm/reducer';
import { abReducer } from '../../config/ab/reducer';
import { AB_KEY } from '../../config/ab/constants';
import { seoReducer, SEO_KEY } from '../../Shared/Seo';
import { searchReducer, SEARCH_KEY } from '../../Search/state';

export default {
    [IN_NETWORK_INSURANCE_KEY]: inNetworkInsuranceReducer,
    [INSURANCE_PICKER_KEY]: insurancePickerReducer,
    [INSURANCE_STATE_KEY]: insuranceReducer,
    [LOCATIONS_CAROUSEL_KEY]: locationsCardCarouselReducer,
    [NEW_EXISTING_RADIO_STATE_KEY]: newExistingRadioReducer,
    [PICTURE_GALLERY_KEY]: pictureGalleryReducer,
    [PROCEDURE_DROPDOWN_STATE_KEY]: procedureDropdownReducer,
    [REVIEWS_KEY]: reviewsReducer,
    [NEXT_AVAILABILITY_KEY]: nextAvailabilityReducer,
    [ROOT_KEY]: pageReducer,
    [INVITE_DOCTOR_FORM_KEY]: inviteDoctorFormReducer,
    [AB_KEY]: abReducer,
    [SEO_KEY]: seoReducer,
    [UNIVERSAL_SEARCH_KEY]: universalSearchReducer,
    [SEARCH_KEY]: searchReducer,
};
